import React, { useState } from "react";
import { Input, Button, Card, Typography } from "@material-tailwind/react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Registration = () => {
  const [form, setForm] = useState({
    empName: "",
    phone: "",
    email: "",
    dob: "",
    department: "",
    salary: "",
    address: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // TODO: Replace with your API call
    setTimeout(() => {
      toast.success("Registration successful!");
      setForm({
        empName: "",
        phone: "",
        email: "",
        dob: "",
        department: "",
        salary: "",
        address: "",
        password: "",
      });
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white relative overflow-hidden px-2 py-8">
      <div className="w-full max-w-xl mx-auto px-4 py-8 md:py-12 z-10">
        <Typography variant="h2" className="text-center font-bold mb-2 text-black tracking-wide">
          Employee Registration
        </Typography>
        <Typography className="text-center text-gray-600 text-lg mb-6">
          Fill the information carefully
        </Typography>
        <Card className="p-6 md:p-8 shadow-lg rounded-2xl bg-white">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <Input
                  label="Employee Name"
                  name="empName"
                  value={form.empName}
                  onChange={handleChange}
                  required
                  color="pink"
                  className="bg-white"
                />
              </div>
              <div className="flex-1">
                <Input
                  label="Phone Number"
                  name="phone"
                  type="tel"
                  value={form.phone}
                  onChange={handleChange}
                  required
                  color="pink"
                  className="bg-white"
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <Input
                  label="Email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  color="pink"
                  className="bg-white"
                />
              </div>
              <div className="flex-1">
                <Input
                  label="Date of Birth"
                  name="dob"
                  type="date"
                  value={form.dob}
                  onChange={handleChange}
                  required
                  color="pink"
                  className="bg-white"
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <Input
                  label="Department"
                  name="department"
                  value={form.department}
                  onChange={handleChange}
                  required
                  color="pink"
                  className="bg-white"
                />
              </div>
              <div className="flex-1">
                <Input
                  label="Salary"
                  name="salary"
                  type="number"
                  value={form.salary}
                  onChange={handleChange}
                  required
                  color="pink"
                  className="bg-white"
                />
              </div>
            </div>
            <Input
              label="Address"
              name="address"
              value={form.address}
              onChange={handleChange}
              required
              color="pink"
              className="bg-white"
            />
            <Input
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
              color="pink"
              className="bg-white"
            />
            <div className="flex justify-center mt-4">
              <Button
                type="submit"
                color="pink"
                className="text-black font-semibold text-lg rounded-lg px-12 py-3 shadow-md hover:bg-pink-700 transition-all duration-200"
                style={{ minWidth: "180px" }}
                disabled={loading}
              >
                {loading ? "Registering..." : "Register"}
              </Button>
            </div>
          </form>
        </Card>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Registration;